import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import SwiperLink from '../SwiperLink';
import styles from './index.module.scss';

export default function EcosystemSection() {
    const { t } = useLang('theProduct.EcosystemSection');
    const { locale } = useRouter();
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756886141016/OCEAN%20Smart%20Electrical%20Panel%2040.png',
            title: t('card1'),
            href: `https://www.ecoflow.com/${locale}/ocean-smart-electrical-panel-40`,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756886140605/Frame%201612707762.png',
            title: t('card2'),
            href: `https://www.ecoflow.com/${locale}/ocean-smart-meter-backup-switch`,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756888711855/OCEAN%20EV%20Charger%20%20(11kW).png',
            title: t('card3'),
            href: `https://www.ecoflow.com/${locale}/ocean-ev-charger`,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756886141259/PowerInsight%202%20Monitor.png',
            title: t('card4'),
            href: ``,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1756886140454/EcoFlow%20APP.png',
            title: t('card5'),
            href: `https://www.ecoflow.com/${locale}/app`,
        },
    ];

    return (
        <div className={`${styles.EcosystemSection}`}>
            <h2 className="title">{t('title')}</h2>
            <SwiperLink items={itemsA} />
        </div>
    );
}
